
import api from './api'

export default {

    list() {

        return api.get('/modes-livraison', {})
            .then( json => json.data )
            
    }
}
